var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 0C7.163 0 0 6.96 0 15.544C0 24.129 7.163 31.088 16 31.088C24.837 31.088 32 24.129 32 15.544C32 6.959 24.837 0 16 0ZM15.554 13.172L15.521 12.634C15.421 11.241 16.304 9.967 17.703 9.474C18.218 9.298 19.091 9.276 19.662 9.429C19.886 9.495 20.311 9.715 20.613 9.912L21.161 10.274L21.766 10.088C22.102 9.989 22.549 9.824 22.751 9.715C22.941 9.615 23.109 9.561 23.109 9.594C23.109 9.781 22.695 10.417 22.348 10.769C21.878 11.262 22.012 11.306 22.963 10.977C23.534 10.79 23.545 10.79 23.433 10.999C23.366 11.109 23.019 11.493 22.65 11.844C22.023 12.448 21.99 12.514 21.99 13.019C21.99 13.799 21.61 15.423 21.229 16.312C20.523 17.98 19.013 19.704 17.502 20.571C15.375 21.789 12.544 22.096 10.16 21.383C9.365 21.142 8 20.527 8 20.417C8 20.384 8.414 20.34 8.918 20.329C9.96928 20.3072 10.9993 20.0285 11.918 19.517L12.521 19.166L11.827 18.936C10.843 18.606 9.959 17.849 9.735 17.135C9.668 16.905 9.69 16.893 10.317 16.893L10.966 16.883L10.417 16.63C9.768 16.312 9.175 15.774 8.884 15.225C8.671 14.83 8.403 13.831 8.481 13.755C8.504 13.721 8.739 13.787 9.007 13.875C9.779 14.149 9.88 14.084 9.433 13.622C8.593 12.788 8.336 11.548 8.739 10.373L8.929 9.846L9.668 10.56C11.178 11.998 12.958 12.854 14.995 13.106L15.555 13.172H15.554Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.ecb9249e6a467fefab7a55afcf80960c.svg";
export { ForwardRef as ReactComponent };